<template>
  <li class="owc-header-navigation-tool-list">
    <ValidationBoxWrapper v-if="isEditMode">
      <slot slot="validation-box" name="validation-box" />
    </ValidationBoxWrapper>
    <h3 v-if="headline" class="owc-header-navigation-tool-list__headline">{{ headline }}</h3>
    <!--FIXME: Missing label for tools list -->
    <ul aria-label="">
      <li
        v-for="link in links"
        :key="link.label"
        class="owc-header-navigation-tool-list__linkOut"
        role="none"
      >
        <a
          class="owc-header-navigation-tool-list__linkOutAnchor"
          :href="link.url"
          :target="link.target"
          @click="handleLinkClick(link)"
          data-track="false"
          role="menuitem"
        >
          <wb-icon
            class="owc-header-navigation-tool-list__linkOutIcon"
            aria-hidden="true"
            :name="link.iconId"
          ></wb-icon>
          {{ link.label }}
        </a>
      </li>
    </ul>
  </li>
</template>

<script lang="ts">
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import {
  HeaderNavigationToolListComponent,
  HeaderNavigationToolListComputed,
  HeaderNavigationToolListMethods,
  HeaderNavigationToolListProps,
  HeaderNavigationToolListData,
} from '@owc-packages/Header/src/HeaderNavigationToolList';
import headerMixin from '@owc-utils/Mixins/Header';
import headerListMixin from '@owc-utils/Mixins/HeaderListMixin';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';

export default (ComponentInitializeDispatcher as HeaderNavigationToolListComponent).extend<
  HeaderNavigationToolListData,
  HeaderNavigationToolListMethods,
  HeaderNavigationToolListComputed,
  HeaderNavigationToolListProps
>({
  name: 'owc-header-navigation-tool-list',
  components: {
    ValidationBoxWrapper,
  },
  mixins: [headerMixin, headerListMixin, OwcDataComponent],
});
</script>

<style lang="scss" scoped>
@import '@owc-styles/utils';
@import './styles/flyout-vars';

.owc-header-navigation-tool-list {
  @include breakpoint-to(mq4) {
    @include wb-content-width;
  }

  margin-bottom: $flyout-spacing-major;

  color: var(--wb-grey-60);

  @include breakpoint-from(mq5) {
    margin-top: $flyout-spacing;
    padding: 0;
  }

  &__headline {
    @include wb-type-copy-secondary;

    margin-bottom: $flyout-spacing-small;

    @include breakpoint-from(mq3) {
      color: var(--wb-grey-45);
    }
    @include breakpoint-from(mq5) {
      @include wb-type-copy;
    }
  }
  &__linkOut {
    @include wb-type-copy;

    display: flex;
    align-items: center;

    min-height: $button-clickable-area;
    margin-bottom: $flyout-spacing-extra-small;

    color: var(--wb-grey-45);

    &:last-child {
      margin-bottom: 0;
    }

    @include breakpoint-from(mq5) {
      min-height: $button-clickable-area--small;
      margin-bottom: $flyout-spacing-small;
    }

    &:hover {
      color: $wb-black;
    }
  }
  &__linkOutAnchor {
    color: inherit;

    text-decoration: none;
  }
  &__linkOutIcon {
    display: inline-flex;

    width: $button-inner-icon-size--small;
    height: $button-inner-icon-size--small;

    margin-right: $flyout-spacing-small;

    @include breakpoint-from(mq3) {
      width: $button-inner-icon-size--large;
      height: $button-inner-icon-size--large;
    }
  }
}
</style>
